<style src="./FieldDate.scss" lang="scss"></style>
<template>
  <section class="mirror-field field-date">
    <fieldset>
      <label>
        <input
          type="text"
          v-model="fieldData"
          v-mask="'##/##/####'" />

        <span class="title">
          {{ title }}
        </span>
      </label>
    </fieldset>
  </section>
</template>

<script>
import { mask } from 'vue-the-mask'

export default {
  name: 'FieldDate',
  props: {
    title: '',
    value: ''
  },
  directives: {
    mask
  },
  data () {
    return {
      fieldData: ''
    }
  },
  watch: {
    fieldData (v) {
      this.$emit('input', v)
    }
  },
  mounted () {
    this.fieldData = this.value
  }
}
</script>


// WEBPACK FOOTER //
// src/components/bid-mirror/mirror-form/components/field-date/FieldDate.vue